import React, { useEffect } from "react";
import { Wrapper } from "./Login.styled";
import LoginForm from "components/pageSection/Login/LoginForm";
import { checkAthenticatedUser, getUser } from "utils/auth";
import { useHistory } from "react-router";

const LoginPage = () => {
  const history = useHistory();

  useEffect(() => {
    if (checkAthenticatedUser()) {
      const user = getUser();
      user?.role === "Setter"
        ? history.push("/setter-leader-board")
        : history.push("/closer-leader-board");
    }
  }, []);
  return (
    <Wrapper>
      <div className="login-form">
        <LoginForm />
      </div>
    </Wrapper>
  );
};

export default LoginPage;
